import React, { useState } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));


class SnackBarUtil{
  open = () => {}
  close = () => {}
}

export var GlobalSnackBarUtil = new SnackBarUtil();

export default function GlobalSnackBar() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const defSnack = {
    message:'',severity:'success',duration:6000,onCloseHandler:()=>{
        setOpen(false)
    }
  }

  const [snackData, setSnackData] = useState(defSnack);



  GlobalSnackBarUtil.open = (data,options) => {
    // setOpen(true);
    // setSnackData({
    //     ...defSnack,
    //     ...data
    // })
    let op = {};
    if(options){
      op = {
        ...options
      }
    }


    enqueueSnackbar(data.message,{
      variant:data.severity,      
      ...op
    })
  }
  GlobalSnackBarUtil.close = () => {
      setOpen(false)
  }
  return (
      <div className={classes.root}>
        {
        // <Snackbar open={open} autoHideDuration={snackData.duration} onClose={snackData.onCloseHandler}>
        //   <Alert onClose={snackData.onCloseHandler} severity={snackData.severity}>
        //     {snackData.message}
        //   </Alert>
        // </Snackbar>
        }
      </div>    
  );
}